module.exports = __webpack_public_path__ + "static/teammarketing-b994688fd005cb06130665729c20ec17.jpg";